import "./index.less";
import * as React from "react";
import { AtBadge, AtCard, AtCheckableCard, AtLinkBase } from "@atman/design-system";
import { CompDevLearningResource, CompetencyDevelopmentLearningResourceType } from "@atman/business";
import { observer } from "mobx-react";

export interface ILearningResourceProps {
    learningResource: CompDevLearningResource;
    parentId?: string;
    checked?: boolean;
    onClick?: () => void;
}

export const LearningResource: React.FC<ILearningResourceProps> = observer((props) => {
    const { learningResource, parentId, checked, onClick } = props;

    const topContent: JSX.Element = (
        <AtBadge size="sm" color="primary" badgeStyle="fill-light">
            {`competencyDevelopment.learningResourceType.${CompetencyDevelopmentLearningResourceType[
                learningResource.type
            ].toCamel()}`.localize()}
        </AtBadge>
    );

    const bottomContent: JSX.Element = (
        <>
            {learningResource.url ? (
                <AtLinkBase
                    href={learningResource.url}
                    color="secondary"
                    target="_blank"
                    onClick={(e) => e.stopPropagation()}
                    title={learningResource.name}
                    underlined
                >
                    {learningResource.name}
                </AtLinkBase>
            ) : (
                <span>{learningResource.name}</span>
            )}
            <span className="authors">{`${"global.by".localize()} ${learningResource.authors}`}</span>
        </>
    );

    return checked !== undefined && onClick ? (
        <AtCheckableCard
            id={`${parentId}-${learningResource.id}`}
            className="LearningResource"
            checked={checked}
            onTopSectionClick={onClick}
            topContent={topContent}
        >
            {bottomContent}
        </AtCheckableCard>
    ) : (
        <AtCard className="LearningResource" topContent={topContent}>
            {bottomContent}
        </AtCard>
    );
});
